export default "__VITE_ASSET__BTVYi34Z__"